export default __webpack_public_path__ + "static/media/cs_icon_02_on.28d0bbc9.png";